import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { pushModal } from '../../../Modals/redux/basicActions';
import { ModalType } from '../../../Modals/redux/types';
export const reduxModuleLoaded = createAction(`${actionKey}.REDUX_READY`, ()=>({}));
export const subscribeToTier = createAction(`${actionKey}.SUBSCRIBE_TO_TIER`, (tier)=>({
        tier
    }));
export const pushUnsubscribeModal = (tier)=>pushModal(ModalType.TIER_UNSUBSCRIBE, {
        params: {
            tier
        },
        wrapInModal: false
    });
export const pushUnsubscribeModalByUsername = (username)=>pushModal(ModalType.TIER_UNSUBSCRIBE_BY_USERNAME, {
        params: {
            username
        },
        wrapInModal: false
    });
export const unsubRequestByUsername = createAction(`${actionKey}.UNSUBSCRIBE_REQUEST_BY_USERNAME`, (username)=>({
        username
    }));
export const unsubRequest = createAction(`${actionKey}.UNSUBSCRIBE_REQUEST`, (tier)=>({
        tier
    }));
export const overrideSubscribeMatureFilter = createAction(`${actionKey}.OVERRIDE_SUBSCRIBE_MATURE_FILTER`, (tier)=>({
        tier
    }));
export const changeTier = createAction(`${actionKey}.CHANGE_TIER`, (currentTier, newTier)=>({
        currentTier,
        newTier
    }));
export const pushChangeTierModal = (currentTier, newTier, isDowngrade)=>pushModal(ModalType.TIER_CHANGE, {
        params: {
            currentTier,
            newTier,
            isDowngrade
        }
    });
